import "../gdn-responsive-layout-1.css";
import GdnAdTemplate from "../GdnAdTemplate";

interface GdnResponsive1200x628AdsProps {
  id: string;
  zoom: number;
}

/** Google Display Network responsive landscape format from Figma layout 1. */
const GdnResponsive1200x628Ads = ({id, zoom}: GdnResponsive1200x628AdsProps) => (
  <GdnAdTemplate
    id={id}
    zoom={zoom}
    variant="stacked"
    layoutVariants={{2: "responsive-horizontal", 3: "responsive-stacked"}}
    showContent={false}
    defaultTransform={{x: 0, y: -900, scale: 0.8}}
  />
);

export default GdnResponsive1200x628Ads;
